"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfPictureExportStrategy = void 0;
var rtf_picture_exporter_factory_1 = require("./rtf-picture-exporter-factory");
var RtfPictureExportStrategy = (function () {
    function RtfPictureExportStrategy() {
    }
    RtfPictureExportStrategy.prototype.export = function (rtfBuilder, run, imageCache, nonVisualDrawingProperties) {
        this.exportShapePicturePrefix(rtfBuilder);
        var exporter = rtf_picture_exporter_factory_1.RtfPictureExporterFactory.createRtfPictureExporter(rtfBuilder, run, imageCache);
        exporter.exportPicture(nonVisualDrawingProperties);
        this.exportShapePicturePostfix(rtfBuilder);
    };
    return RtfPictureExportStrategy;
}());
exports.RtfPictureExportStrategy = RtfPictureExportStrategy;
